import React from 'react';

function HourglassIcon(props: React.ComponentProps<'svg'>) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" {...props}>
            <path d="M0,22a1.834,1.834,0,0,1,1.392-1.78V15.858C1.392,13.8,3.819,11.81,5.33,11A10.348,10.348,0,0,1,3.551,9.762C2.747,9.068,1.4,7.674,1.4,6.141V1.781A1.834,1.834,0,0,1,0,0H13a1.834,1.834,0,0,1-1.394,1.78v4.36c0,1.529-1.444,2.926-2.3,3.622A11.285,11.285,0,0,1,7.415,11c1.591.81,4.191,2.8,4.191,4.857V20.22A1.834,1.834,0,0,1,13,22ZM3.332,4.395a.948.948,0,0,0-.661.635c-.178.711.652,1.647.661,1.656l.013.01a20.2,20.2,0,0,1,1.665,1.48c.43.5.71.9.915,1.192l.008.01,0,0c.206.3.32.457.41.457.108,0,.417-.457.69-.861a5.886,5.886,0,0,1,.6-.8C7.726,8.094,9.488,6.7,9.5,6.685s.84-.945.661-1.656A.949.949,0,0,0,9.5,4.395a9.5,9.5,0,0,0-3.085-.43A9.537,9.537,0,0,0,3.332,4.395Z"
                  transform="translate(5.501 0.998)"/>
        </svg>
    );
}

export default HourglassIcon;